import Box from "@mui/material/Box";

const toneStyles = {
  pink: {
    backgroundColor: "rgb(252, 231, 243)",
    color: "rgb(236, 72, 153)",
  },
  slate: {
    backgroundColor: "rgb(226, 232, 240)",
    color: "rgb(100, 116, 139)",
  },
  violet: {
    backgroundColor: "rgb(237, 233, 254)",
    color: "rgb(124, 58, 237)",
  },
  yellow: {
    backgroundColor: "rgb(254, 243, 199)",
    color: "rgb(146, 64, 14)",
  },
};

export default function ProductIconTile({
  icon,
  iconSize = 24,
  size = 44,
  sx,
  tone = "violet",
}) {
  const toneStyle = toneStyles[tone] || toneStyles.violet;

  return (
    <Box
      aria-hidden="true"
      sx={[
        {
          alignItems: "center",
          backgroundColor: toneStyle.backgroundColor,
          borderRadius: "7px",
          color: toneStyle.color,
          display: "flex",
          flexShrink: 0,
          height: size,
          justifyContent: "center",
          width: size,
        },
        sx,
      ]}
    >
      <Box
        className="material-symbols-outlined"
        component="span"
        sx={{
          fontSize: iconSize,
          fontVariationSettings: "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24",
          lineHeight: 1,
        }}
      >
        {icon}
      </Box>
    </Box>
  );
}
